import Link from 'next/link';
import { buttonVariants } from '@/components/ui/button';
import { CartMenu } from './cart-menu';
export function UnAuthenticatedActions() {
  return <div className="flex gap-4 md:flex items-center" data-sentry-component="UnAuthenticatedActions" data-sentry-source-file="unauthenticated-actions.tsx">
      <CartMenu data-sentry-element="CartMenu" data-sentry-source-file="unauthenticated-actions.tsx" />
      <div className="hidden sm:flex gap-4">
        <Link href="/signup" className={buttonVariants()} data-sentry-element="Link" data-sentry-source-file="unauthenticated-actions.tsx">
          Sign up
        </Link>
        <Link href="/signin" className={buttonVariants({
        variant: 'outline'
      })} data-sentry-element="Link" data-sentry-source-file="unauthenticated-actions.tsx">
          Log in
        </Link>
      </div>
    </div>;
}